import { render, staticRenderFns } from "./KnowledgeSearchFilter.vue?vue&type=template&id=7bff3548&scoped=true&"
import script from "./KnowledgeSearchFilter.vue?vue&type=script&lang=js&"
export * from "./KnowledgeSearchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff3548",
  null
  
)

export default component.exports